module.exports = __webpack_public_path__ + "files/5ebaee862032012cc76c78503b536f71.svg";